export const categories = [
  { slug: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-line', description: '每日笑料不断，快乐从这里开始' },
  { slug: 'meishi', name: '美食', icon: 'ri-restaurant-line', description: '舌尖上的美味，治愈你的胃' },
  { slug: 'zhishi', name: '知识', icon: 'ri-lightbulb-line', description: '每天学点新知识，充实自己' },
  { slug: 'shenghuo', name: '生活', icon: 'ri-heart-line', description: '记录美好生活，发现身边精彩' },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-line', description: '好歌不断，耳朵的盛宴' },
  { slug: 'keji', name: '科技', icon: 'ri-smartphone-line', description: '前沿科技资讯，数码评测' },
  { slug: 'lvxing', name: '旅行', icon: 'ri-earth-line', description: '足不出户看世界，旅行灵感' },
  { slug: 'dongwu', name: '萌宠', icon: 'ri-bear-smile-line', description: '可爱的动物们，治愈每一天' },
];

export const videoData = [
  {
    id: 1,
    title: '猫咪的日常：这只会开门的小橘猫太聪明了',
    category: 'dongwu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cute%20orange%20tabby%20cat%20sitting%20by%20a%20door%2C%20warm%20indoor%20lighting%2C%20cozy%20home%20atmosphere%2C%20soft%20natural%20light%20through%20window%2C%20minimalist%20interior%2C%20shallow%20depth%20of%20field%2C%20whimsical%20and%20heartwarming%20pet%20photography%20style%20with%20warm%20neutral%20tones&width=800&height=450&seq=video-cover-01&orientation=landscape',
    duration: '03:25',
    views: '128.6万',
    author: '萌宠日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20avatar%20portrait%2C%20warm%20smile%2C%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot%20style%2C%20soft%20bokeh%2C%20warm%20neutral%20tones&width=100&height=100&seq=author-01&orientation=squarish',
    description: '小橘猫"橙子"每天都会自己开门进房间叫主人起床，这智商简直成精了！一起来看看这只聪明的小家伙的日常。',
    tags: ['猫咪', '萌宠', '橘猫', '宠物日常'],
    date: '2026-08-10',
  },
  {
    id: 2,
    title: '街头美食探店：藏在巷子里的30年老店，一碗面只要8块！',
    category: 'meishi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20steaming%20bowl%20of%20Chinese%20noodles%20on%20a%20wooden%20table%20in%20a%20traditional%20small%20restaurant%2C%20warm%20ambient%20lighting%2C%20steam%20rising%2C%20chopsticks%20beside%20the%20bowl%2C%20cozy%20nostalgic%20atmosphere%2C%20food%20photography%20style%20with%20rich%20textures%20and%20warm%20earth%20tones&width=800&height=450&seq=video-cover-02&orientation=landscape',
    duration: '05:18',
    views: '89.3万',
    author: '吃货小分队',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20with%20friendly%20expression%2C%20casual%20style%2C%20studio%20portrait%2C%20clean%20background%2C%20warm%20neutral%20lighting%2C%20professional%20headshot&width=100&height=100&seq=author-02&orientation=squarish',
    description: '在广州老城区发现一家开了30年的面馆，老板每天凌晨4点开始熬汤，一碗牛腩面只要8块钱，味道却让人惊艳！',
    tags: ['美食探店', '街头小吃', '牛腩面', '老店'],
    date: '2026-08-09',
  },
  {
    id: 3,
    title: '5分钟搞懂量子计算：从零开始的硬核科普',
    category: 'zhishi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20quantum%20computing%20visualization%20with%20glowing%20circuit%20patterns%2C%20dark%20background%20with%20cyan%20and%20gold%20light%20trails%2C%20abstract%20technology%20concept%2C%20clean%20minimalist%20design%2C%20educational%20science%20visualization%20style&width=800&height=450&seq=video-cover-03&orientation=landscape',
    duration: '05:42',
    views: '256.1万',
    author: '科学星球',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20science%20communicator%20portrait%2C%20professional%20yet%20approachable%2C%20studio%20lighting%2C%20clean%20background%2C%20warm%20neutral%20tones&width=100&height=100&seq=author-03&orientation=squarish',
    description: '量子计算听起来很玄乎？别怕！这期视频用最通俗易懂的方式，带你5分钟搞懂量子计算的基本原理，保证你能听懂！',
    tags: ['量子计算', '科普', '科技', '硬核知识'],
    date: '2026-08-08',
  },
  {
    id: 4,
    title: '今日份快乐源泉：这些搞笑瞬间我能笑一整天！',
    category: 'gaoxiao',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20golden%20retriever%20making%20a%20silly%20face%20in%20a%20bright%20sunny%20living%20room%2C%20playful%20atmosphere%2C%20natural%20window%20light%2C%20warm%20and%20cheerful%20mood%2C%20clean%20modern%20interior%2C%20humorous%20pet%20photography%20with%20warm%20natural%20tones&width=800&height=450&seq=video-cover-04&orientation=landscape',
    duration: '04:12',
    views: '342.5万',
    author: '快乐源泉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20cheerful%20young%20Chinese%20content%20creator%20portrait%2C%20bright%20smile%2C%20studio%20lighting%2C%20clean%20background%2C%20warm%20and%20friendly%20atmosphere&width=100&height=100&seq=author-04&orientation=squarish',
    description: '生活不易，但快乐很简单！收集了本周最搞笑的宠物、萌娃和日常翻车瞬间，笑到停不下来！',
    tags: ['搞笑', '快乐', '萌宠', '翻车合集'],
    date: '2026-08-07',
  },
  {
    id: 5,
    title: '一个人也要好好吃饭：10分钟搞定高颜值午餐',
    category: 'meishi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautifully%20plated%20homemade%20lunch%20on%20a%20minimalist%20wooden%20table%2C%20natural%20window%20light%2C%20fresh%20ingredients%20visible%2C%20clean%20modern%20kitchen%20background%2C%20food%20photography%20with%20warm%20natural%20tones%20and%20soft%20shadows&width=800&height=450&seq=video-cover-05&orientation=landscape',
    duration: '03:50',
    views: '67.8万',
    author: '一人食厨房',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20female%20food%20blogger%20portrait%2C%20warm%20and%20inviting%20expression%2C%20studio%20lighting%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=100&height=100&seq=author-05&orientation=squarish',
    description: '独居生活也要有仪式感！今天分享三道简单又好看的一人食午餐，10分钟就能搞定，营养均衡还超上镜。',
    tags: ['一人食', '美食教程', '午餐', '快手菜'],
    date: '2026-08-06',
  },
  {
    id: 6,
    title: 'iPhone 17 Pro Max 深度体验一个月：这些变化太真实了',
    category: 'keji',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20on%20a%20clean%20minimalist%20desk%20setup%2C%20natural%20light%20from%20window%2C%20sleek%20design%2C%20tech%20product%20photography%2C%20warm%20wooden%20desk%20surface%2C%20clean%20aesthetic%20with%20soft%20shadows&width=800&height=450&seq=video-cover-06&orientation=landscape',
    duration: '08:35',
    views: '189.2万',
    author: '数码评测室',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20tech%20reviewer%20portrait%2C%20professional%20look%2C%20studio%20lighting%2C%20clean%20background%2C%20friendly%20expression&width=100&height=100&seq=author-06&orientation=squarish',
    description: '用了一个月iPhone 17 Pro Max，这篇深度体验告诉你那些发布会上没说的真实感受，升级到底值不值？',
    tags: ['iPhone', '数码评测', '手机', '科技'],
    date: '2026-08-05',
  },
  {
    id: 7,
    title: '周杰伦《晴天》指弹吉他翻弹，前奏一响就是青春！',
    category: 'yinyue',
    coverImage: 'https://readdy.ai/api/search-image?query=An%20acoustic%20guitar%20resting%20on%20a%20wooden%20stand%20near%20a%20window%20with%20warm%20sunlight%20streaming%20in%2C%20cozy%20atmosphere%2C%20musical%20vibe%2C%20clean%20minimalist%20room%2C%20warm%20golden%20hour%20lighting%2C%20artistic%20photography&width=800&height=450&seq=video-cover-07&orientation=landscape',
    duration: '04:28',
    views: '421.7万',
    author: '吉他少年',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20male%20musician%20portrait%2C%20artistic%20vibe%2C%20studio%20lighting%2C%20clean%20background%2C%20warm%20atmosphere&width=100&height=100&seq=author-07&orientation=squarish',
    description: '周杰伦的《晴天》承载了太多人的青春记忆。这次用指弹的方式重新演绎，前奏一响，回忆全回来了。',
    tags: ['周杰伦', '吉他', '指弹', '晴天'],
    date: '2026-08-04',
  },
  {
    id: 8,
    title: '云南大理三日游攻略：人均1500元玩到不想走',
    category: 'lvxing',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Dali%20ancient%20town%20landscape%20with%20Erhai%20Lake%20and%20Cangshan%20Mountains%20in%20background%2C%20golden%20sunset%20light%2C%20traditional%20Bai%20architecture%2C%20peaceful%20atmosphere%2C%20travel%20photography%20style%20with%20warm%20golden%20tones&width=800&height=450&seq=video-cover-08&orientation=landscape',
    duration: '06:50',
    views: '178.4万',
    author: '旅行日记',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20travel%20vlogger%20portrait%2C%20adventurous%20spirit%2C%20outdoor%20lighting%2C%20clean%20natural%20background%2C%20warm%20friendly%20expression&width=100&height=100&seq=author-08&orientation=squarish',
    description: '大理真的太美了！分享我们的三日游路线，住洱海边、逛古城、吃地道美食，人均只要1500元，超详细攻略请收好！',
    tags: ['大理', '旅行攻略', '云南', '三日游'],
    date: '2026-08-03',
  },
  {
    id: 9,
    title: '打工人日常vlog：深圳互联网人的真实一天',
    category: 'shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20modern%20office%20workspace%20with%20laptop%20and%20coffee%2C%20natural%20light%20from%20large%20windows%2C%20city%20skyline%20view%2C%20clean%20minimalist%20desk%20setup%2C%20professional%20yet%20cozy%20atmosphere%2C%20warm%20morning%20light&width=800&height=450&seq=video-cover-09&orientation=landscape',
    duration: '07:15',
    views: '95.3万',
    author: '城市青年',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20professional%20portrait%2C%20modern%20urban%20style%2C%20studio%20lighting%2C%20clean%20background%2C%20warm%20neutral%20tones&width=100&height=100&seq=author-09&orientation=squarish',
    description: '很多朋友好奇互联网人的日常是什么样的？来跟我过一天吧，从早上的咖啡到深夜的coding，真实记录。',
    tags: ['vlog', '打工人', '互联网', '日常生活'],
    date: '2026-08-02',
  },
  {
    id: 10,
    title: '哈士奇的迷惑行为大赏：这狗是纯种的没错了！',
    category: 'dongwu',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20funny%20husky%20dog%20with%20blue%20eyes%20making%20a%20silly%20expression%20in%20a%20bright%20living%20room%2C%20playful%20atmosphere%2C%20natural%20light%2C%20clean%20modern%20interior%2C%20humorous%20pet%20photography%20with%20warm%20natural%20tones&width=800&height=450&seq=video-cover-10&orientation=landscape',
    duration: '03:18',
    views: '567.2万',
    author: '二哈的日常',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20pet%20owner%20portrait%2C%20cheerful%20expression%2C%20studio%20lighting%2C%20clean%20background%2C%20warm%20friendly%20atmosphere&width=100&height=100&seq=author-10&orientation=squarish',
    description: '养哈士奇是一种什么体验？本期盘点哈士奇十大迷惑行为，每个都让你怀疑这狗脑回路到底怎么长的！',
    tags: ['哈士奇', '萌宠', '搞笑', '狗狗'],
    date: '2026-08-01',
  },
  {
    id: 11,
    title: '10个让你变聪明的冷知识，最后一个太意外了！',
    category: 'zhishi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20glowing%20lightbulb%20on%20a%20minimalist%20desk%20with%20books%20stacked%20nearby%2C%20warm%20ambient%20lighting%2C%20intellectual%20atmosphere%2C%20clean%20aesthetic%2C%20knowledge%20and%20learning%20theme%20with%20warm%20golden%20tones&width=800&height=450&seq=video-cover-11&orientation=landscape',
    duration: '04:45',
    views: '312.8万',
    author: '知识杂货铺',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20knowledge%20creator%20portrait%2C%20thoughtful%20expression%2C%20studio%20lighting%2C%20clean%20background%2C%20warm%20atmosphere&width=100&height=100&seq=author-11&orientation=squarish',
    description: '这些冷知识真的一个比一个让人惊讶！从动物世界到人体奥秘，10个你绝对不知道的冷知识，最后一个连我都惊了！',
    tags: ['冷知识', '科普', '有趣', '涨知识'],
    date: '2026-07-31',
  },
  {
    id: 12,
    title: '零基础学跳舞挑战：30天后我居然能跳成这样？',
    category: 'shenghuo',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dance%20studio%20with%20mirror%20wall%20and%20wooden%20floor%2C%20warm%20studio%20lighting%2C%20modern%20interior%2C%20clean%20minimalist%20design%2C%20energetic%20atmosphere%2C%20dance%20and%20movement%20theme&width=800&height=450&seq=video-cover-12&orientation=landscape',
    duration: '06:30',
    views: '145.6万',
    author: '舞动青春',
    authorAvatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20dancer%20portrait%2C%20energetic%20expression%2C%20studio%20lighting%2C%20clean%20background%2C%20dynamic%20feel&width=100&height=100&seq=author-12&orientation=squarish',
    description: '作为一个完全零基础的舞蹈小白，我挑战30天每天练舞1小时。从第一天的笨拙到第三十天的蜕变，我自己都不敢相信！',
    tags: ['舞蹈', '挑战', '零基础', '成长'],
    date: '2026-07-30',
  },
];

export const articleContent = [
  {
    id: 1,
    title: '猫咪的日常：这只会开门的小橘猫太聪明了',
    category: 'dongwu',
    content: `
      <p>最近，一只名叫"橙子"的小橘猫在网络上迅速走红。这只不到两岁的猫咪，居然学会了自己开门！</p>
      <p>据主人介绍，橙子是在半年前偶然学会跳上门把手开门的。一开始只是偶尔成功，现在已经熟练到可以随时进出任何房间了。</p>
      <h2>聪明的橘猫</h2>
      <p>动物行为学专家表示，猫咪的学习能力其实比我们想象的要强得多。橘猫尤其以聪明著称，能够通过观察和模仿来学习新的技能。</p>
      <p>橙子的主人说："每天早上七点，它都会准时开门来叫我起床，比闹钟还准时。有时候周末想睡个懒觉都不行。"</p>
      <h2>网友热议</h2>
      <p>视频发布后，短短三天就获得了超过120万次观看。网友们纷纷留言：</p>
      <p>"这智商简直成精了！""我家猫只会拆家，看看人家的猫。""橘猫果然是猫界智商担当。"</p>
      <p>也有人提出了安全建议：建议主人在不必要的时候锁好门，防止猫咪在主人不在家时自己开门跑出去。</p>
    `,
  },
  {
    id: 2,
    title: '街头美食探店：藏在巷子里的30年老店，一碗面只要8块！',
    category: 'meishi',
    content: `
      <p>在广州老城区的一条不起眼的小巷里，藏着一家开了30年的面馆。没有华丽的招牌，没有精致的装修，但每天门口都排着长队。</p>
      <p>老板陈叔今年62岁，从32岁开始做面，一干就是30年。他每天凌晨4点起床开始熬汤，坚持用最传统的做法。</p>
      <h2>一碗面里的30年</h2>
      <p>"汤是面的灵魂，"陈叔说，"我熬汤用的都是当天新鲜的牛骨和鸡骨，大火烧开，小火慢熬，至少四个小时。"</p>
      <p>最让人惊讶的是价格——一碗牛腩面，只要8块钱。在这个物价飞涨的时代，这个价格简直不可思议。</p>
      <p>"涨价？"陈叔摇摇头，"这些街坊邻居照顾了我30年，我不能让他们吃不起。够本就行，不图赚大钱。"</p>
      <h2>食客评价</h2>
      <p>"我从小吃到大，现在带孩子来吃，"一位老顾客说，"味道几十年没变过，就是小时候的那个味。"</p>
      <p>也有外地来的食客专程找过来："在短视频上看到推荐，专门坐了2小时地铁来尝，真的没让人失望！"</p>
    `,
  },
];